module.exports = __webpack_public_path__ + "static/media/icon-slides.71101fd2.svg";